<template>
	<v-sheet>
		<v-main>
			<v-container>
				<v-row class="text-center" align="center" justify="center">
					<v-col cols="12">
						<img
							alt="The404"
							src="/assets/image/The404.svg"
							height="500"
							width="100%"
							class="center"
						/>
					</v-col>
					<v-col cols="12">
						<label class="font-weight-black text-h2 indigo--text darken-2">Ooops!</label><br />
						<label>Uh oh,something looks wrong here</label>
					</v-col>
					<v-col cols="12">
							<v-btn :to="{ name: 'Login' }" rounded color="primary" class="btns" dark large
								>Home
							</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-sheet>
</template>

<script>
export default {
	metaInfo() {
		return {
			title: '404',
		}
	},
}
</script>
